import * as React from "react";
import { onKeyDown } from "@utdanningsdirektoratet/utils/uu";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { capitalize } from "@utdanningsdirektoratet/utils/string";
import styles from "./Toggle.module.less";

type ToggleProps = {
  label: string;
  onChange: (value: boolean) => void;
  value?: boolean;
  disabled?: boolean;
  size?: "small";
  className?: string;
  children?: React.ReactNode;
};

const Toggle = React.forwardRef<HTMLDivElement, ToggleProps>(
  ({ size, disabled, className, label, value = false, onChange, children }, ref) => {
    const onChangeWrapped = (event: React.MouseEvent) => {
      event.stopPropagation();
      if (disabled) return;
      onChange(!value);
    };

    const toggleClass = cls(
      {
        [styles.toggle]: true,
        [styles.toggleActive]: value,
        [styles.toggleDisabled]: disabled,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        [styles[`toggle${capitalize(size)}`]]: size,
      },
      className
    );

    const circleClass = cls({
      [styles.toggleCircle]: true,
      [styles.toggleCircleActive]: value,
      [styles.toggleCircleDisabled]: disabled,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [styles[`toggleCircle${capitalize(size)}`]]: size,
    });

    return (
      <div
        ref={ref}
        tabIndex={0}
        role="switch"
        aria-disabled={disabled}
        aria-checked={value}
        aria-label={label}
        className={toggleClass}
        onKeyDown={onKeyDown(onChangeWrapped)}
        onClick={onChangeWrapped}
      >
        <div className={circleClass}>{!size && children}</div>
      </div>
    );
  }
);

export default Toggle;
